









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'Flip',
})
export default class Flip extends Vue {
  @Prop({ default: 1000 }) readonly duration!: number;
  @Prop({ default: 0 }) readonly count!: number;
  @Prop({ default: true }) readonly autoPlay!: boolean;

  $refs!: {
    flipRef: HTMLElement;
    frontNodeRef: HTMLElement;
    backNodeRef: HTMLElement;
  };

  private isFlipping = false;
  private currentCount = this.count;
  private maxNumber = 0;

  flipDown() {
    if (this.isFlipping) {
      return false;
    }
    this.$refs.frontNodeRef.setAttribute('class', 'digital front number' + this.currentCount);
    const nextCount = this.currentCount >= 9 ? 0 : this.currentCount + 1;
    this.$refs.backNodeRef.setAttribute('class', 'digital back number' + nextCount);

    if (nextCount > this.maxNumber) return;
    this.$refs.flipRef.setAttribute('class', 'flip down go');
    this.isFlipping = true;

    setTimeout(() => {
      this.$refs.flipRef.setAttribute('class', 'flip down');
      this.isFlipping = false;
      this.$refs.frontNodeRef.setAttribute('class', 'digital front number' + nextCount);
      this.currentCount = nextCount;
    }, this.duration);
  }

  flipUp() {
    if (this.isFlipping) {
      return false;
    }
    this.$refs.frontNodeRef.setAttribute('class', 'digital front number' + this.currentCount);
    const nextCount = this.currentCount <= 0 ? 9 : this.currentCount - 1;
    this.$refs.backNodeRef.setAttribute('class', 'digital back number' + nextCount);
    this.$refs.flipRef.setAttribute('class', 'flip up go');
    this.isFlipping = true;
    setTimeout(() => {
      this.$refs.flipRef.setAttribute('class', 'flip up');
      this.isFlipping = false;
      this.$refs.frontNodeRef.setAttribute('class', 'digital front number' + nextCount);
      this.currentCount = nextCount;
    }, this.duration);
  }

  @Watch('count', { deep: true, immediate: true })
  onCountChange(newVal: number, oldVal: number = 0) {
    this.currentCount = oldVal;
    this.maxNumber = newVal;
    if (newVal > oldVal) {
      const interval = setInterval(() => {
        this.flipDown();
        if (this.currentCount >= newVal) {
          clearInterval(interval);
        }
      }, 1000);
    } else if (newVal < oldVal) {
      const interval = setInterval(() => {
        this.flipUp();
        if (this.currentCount <= newVal) {
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  mounted() {
    // 组件挂载后的逻辑
  }
}
